import { renderOnLayer, Layers, AnimationTypes } from '@doordash/component-layer-manager';
import { ViewportToastsContainer } from '../styles.js';
import { TOAST_CONTENT_PROPTYPES, POSITIONS } from '../constants.js';
import ToastsContainer from './ToastsContainer.js';
import React from 'react';
import PropTypes from 'prop-types';

var ViewportToasts = function ViewportToasts(_ref) {
  var toastsToDisplay = _ref.toastsToDisplay,
      toastsToRender = _ref.toastsToRender,
      setToastsToRender = _ref.setToastsToRender,
      position = _ref.position;
  return /*#__PURE__*/React.createElement(ViewportToastsContainer, {
    position: position
  }, Object.keys(toastsToRender).length ? /*#__PURE__*/React.createElement(ToastsContainer, {
    toastsToDisplay: toastsToDisplay,
    position: position,
    toastsToRender: toastsToRender,
    setToastsToRender: setToastsToRender
  }) : undefined);
};

ViewportToasts.propTypes = {
  toastsToDisplay: PropTypes.objectOf(PropTypes.shape(TOAST_CONTENT_PROPTYPES)),
  toastsToRender: PropTypes.objectOf(PropTypes.shape(TOAST_CONTENT_PROPTYPES)),
  setToastsToRender: PropTypes.func,
  position: PropTypes.oneOf(Object.values(POSITIONS))
};
var ViewportConstrainedToasts = renderOnLayer(Layers.Viewport, ViewportToasts, {
  AnimationType: AnimationTypes.Custom
});

export { ViewportConstrainedToasts as default };
